<div class="tvshop-app" #homepage>
  <ng-container *ngIf="pageConfiguration.navigableComponents[0].shouldShowComponent">
    <app-tvshop-header [titleKey]="'eos-tv-shop-ii.title.main-tv-shop-header'"></app-tvshop-header>
    <div class="tvshop-main">
      <div class="subtitle-in-the-spotlight">
        <div [translate]="'eos-tv-shop-ii.title.in-the-spotlight'">In de kijker</div>
        <div class="vat-excl-section">
          <img src="../../../../assets/images/icon-information.svg" alt="">
          <div class="vat-excl-section--label" [translate]="'eos-tv-shop-ii.vat-excl-lbl'" *ngIf="mainPack.isSoho"> All prices are VAT exclusive</div>
        </div>
      </div>
      <app-navigable-banner [pack]="mainPack"
                            [ownerComponent]="ownerComponent" [x]="0"
                            [y]="pageConfiguration.navigableComponents[0].yPosition">
      </app-navigable-banner>
    </div>
  </ng-container>
  <ng-container *ngIf="pageConfiguration.navigableComponents[1].shouldShowComponent">
    <app-tvshop-header [titleKey]="'eos-tv-shop-ii.title.main-tv-shop-header'"></app-tvshop-header>
    <div class="tvshop-main">
      <div class="subtitle-in-the-spotlight">
        <span [translate]="'eos-tv-shop-ii.title.streaming-bundles'">Minder zoeken meer kijken</span>
      </div>
    </div>
    <div class="carousel">
      <div class="subtitle-our-packages">
        <span [translate]="'eos-tv-shop-ii.title.our-streaming-bundles'">De beste combinatiedeals</span>
      </div>
      <app-product-carousel [isBigTile]="true" [showPromoBadge]="true" [packs]="streamingBundlesForHeroCarousel"
                            showSubtitle="true"
                            [yIndex]="pageConfiguration.navigableComponents[1].yPosition"></app-product-carousel>
    </div>
  </ng-container>
  <div class="carousel" *ngIf="pageConfiguration.navigableComponents[2].shouldShowComponent">
      <div class="subtitle-our-packages">
        <div [translate]="'eos-tv-shop-ii.title.our-packages'">Onze paketten</div>
        <div class="vat-excl-section" *ngIf="mainPack.isSoho">
          <img src="../../../../assets/images/icon-information.svg" alt="">
          <div class="vat-excl-section--label" [translate]="'eos-tv-shop-ii.vat-excl-lbl'"> All prices are VAT exclusive</div>
        </div>

      </div>

    <app-product-carousel [packs]="productsInCarousel"
                          showSubtitle="true"
                          [yIndex]="pageConfiguration.navigableComponents[2].yPosition"></app-product-carousel>
  </div>
  <div class="carousel" *ngIf="pageConfiguration.navigableComponents[3].shouldShowComponent">
    <div class="subtitle-our-packages">
      <span [translate]="'eos-tv-shop-ii.title.our-streaming-services'">Onze streamingdiensten</span>
    </div>
    <div class="subtitle-streaming-services">
      <span [translate]="'eos-tv-shop-ii.title.our-streaming-services-discount-percent'">Combineer 2 of meer streamingdiensten en geniet van 5% korting</span>
    </div>
    <app-product-carousel [packs]="tvPackGroupsInCarousel"
                          [showSubtitle]="true"
                          [yIndex]="pageConfiguration.navigableComponents[3].yPosition"></app-product-carousel>
  </div>
</div>
